import {Redirect, Route, useLocation} from "react-router-dom";
import React from "react";
import {connect} from "react-redux";

const AdminRoute = ({ component: Comp, path, user, loaded, currentEvent, ...rest }) => {

    const location = useLocation();

    return (
        <Route
            path={path}
            {...rest}
            render={props => {

                const pass = () => {
                    return (
                        <Comp {...props} {...rest} />
                    );
                }

                const fail = () => {
                    return (
                        <Redirect to='/login' />
                    );
                }

                if (!loaded || !user) {
                    return fail();
                }

                if (!user.role?.is_admin) {
                    return fail();
                }

                if(!currentEvent && location.pathname !== '/') {
                    return <Redirect to='/' />
                }

                //Otherwise logged in user is good enaught.
                return pass();
            }}
        />
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    loaded: state.auth?.loaded,
    isAuthenticated: state.auth?.isAuthenticated,
    currentEvent: state.event?.current
});

export default  connect(mapStateToProps)(AdminRoute);
